import React from 'react';
import { RushPremiumPolicyConfig } from './RushPremiumPolicyConfig';
import type { RushPremiumTier } from '@/types';

interface RushPremiumPolicySectionProps {
  rushPremiumPolicy: RushPremiumTier[];
  onRushPremiumPolicyChange: (rules: RushPremiumTier[]) => void;
}

export const RushPremiumPolicySection: React.FC<RushPremiumPolicySectionProps> = ({
  rushPremiumPolicy,
  onRushPremiumPolicyChange,
}) => {
  return (
    <div className="space-y-4">
      <RushPremiumPolicyConfig
        policy={rushPremiumPolicy}
        onChange={onRushPremiumPolicyChange}
      />
    </div>
  );
};
